import type { AdminUser } from 'api/adminApi';

export type OnboardingStepId = 1 | 2 | 3 | 4 | 5 | 6;

export type OnboardingStepMeta = {
    id: OnboardingStepId;
    title: string;
    timestampField: keyof AdminUser | null;
};

export const ONBOARDING_STEPS: OnboardingStepMeta[] = [
    { id: 1, title: 'Паспортные данные', timestampField: 'passportUploadedAt' },
    { id: 2, title: 'Анкета торгового опыта', timestampField: 'questionnaireSubmittedAt' },
    { id: 3, title: 'Активация через бота', timestampField: 'botContactedAt' },
    { id: 4, title: 'Установка софта', timestampField: 'softwareConfirmedAt' },
    { id: 5, title: 'Добро пожаловать', timestampField: 'onboardingCompletedAt' },
    { id: 6, title: 'Оформление документов (CRM)', timestampField: 'crmFormConfirmedAt' },
];

export const ONBOARDING_STEP_TITLES: Record<OnboardingStepId, string> = {
    1: 'Паспортные данные',
    2: 'Анкета торгового опыта',
    3: 'Активация через бота',
    4: 'Установка софта',
    5: 'Добро пожаловать',
    6: 'Оформление документов (CRM)',
};
